'use es6';

import { css } from 'styled-components';
import { TABLETWIDTH, LAPTOPHEIGHT } from './constants';
export const LaptopAndAbove = (...content) => css(["@media only screen and (min-width:", "){", ";}"], TABLETWIDTH + 100, css(...content));
export const TabletAndBelow = (...content) => css(["@media only screen and (max-width:", "){", ";}"], TABLETWIDTH, css(...content));
export const LaptopHeight = content => css(["@media only screen and (max-height:", "){", ";}"], LAPTOPHEIGHT, css(...content));